// There is a Vite built-in way to make type augmentation available globally, but due to the project
// currently is setup, this broke typescript type checking at the time of writing this code.
// so we manually type convert and return it as env.
export const env = import.meta.env as unknown as ImportMetaEnv;

export interface ImportMetaEnv {
    /**
     * e.g. v40.0.0, dev, dev-local
     */
    readonly VITE_APP_VERSION: string;

    /**
     * e.g. local, review-app, staging, production, ...
     */
    readonly VITE_APP_ENVIRONMENT: string;

    /**
     * e.g. https://host.tld
     */
    readonly VITE_APP_BASE_URL: string;

    /**
     * e.g. https://host.tld/api
     */
    readonly VITE_API_BASE_URL: string;

    /**
     * e.g. /features
     */
    readonly VITE_FEATURES_API_ENDPOINT: string;

    /**
     * e.g. /graphql
     */
    readonly VITE_GRAPHQL_API_ENDPOINT: string;

    /**
     * e.g. /login_check
     */
    readonly VITE_LOGIN_CHECK_API_ENDPOINT: string;

    /**
     * e.g. /logout
     */
    readonly VITE_LOGOUT_API_ENDPOINT: string;

    /**
     * e.g. /oauth/login/oidc/logout
     */
    readonly VITE_OICD_LOGOUT_ENDPOINT: string;

    /**
     * e.g. /performance_log
     */
    readonly VITE_PERFORMANCE_LOG_API_ENDPOINT: string;

    /**
     * e.g. /ping
     */
    readonly VITE_PING_API_ENDPOINT: string;

    /**
     * e.g. /machine/list_directory
     */
    readonly VITE_MACHINE_LIST_DIRECTORY_API_ENDPOINT: string;

    /**
     * e.g. /media_objects/ckeditor
     */
    readonly VITE_MEDIA_OBJECTS_CKEDITOR_API_ENDPOINT: string;

    /**
     * e.g. https://mercure.smartlearn.test
     * defaults to window.location.origin if empty
     */
    readonly VITE_MERCURE_BASE_URL: string;

    /**
     * e.g. /.well-known/mercure
     */
    readonly VITE_MERCURE_ENDPOINT: string;

    /**
     * Validity time of refresh token in seconds
     * e.g. 900
     */
    readonly VITE_REFRESH_TOKEN_EXPIRE_TIME: string;

    /**
     * e.g. /token/refresh
     */
    readonly VITE_REFRESH_TOKEN_API_ENDPOINT: string;

    /**
     * URL to download Safe Exam Browser for Windows
     */
    readonly VITE_APP_SEB_WINDOWS_DOWNLOAD_URL: string;

    /**
     * URL to download Safe Exam Browser for macOS
     */
    readonly VITE_APP_SEB_MAC_OS_DOWNLOAD_URL: string;

    /**
     * Whether Sentry should be enabled or not, where '1' is enabled and '0' is disabled.
     */
    readonly VITE_APP_SENTRY_ENABLED: undefined | '0' | '1';

    /**
     * e.g. 'https://<PUBLIC_KEY>@sentry.io/<PROJECT_ID>'
     */
    readonly VITE_APP_SENTRY_DSN: string;

    /**
     * Performance Monitoring.
     * @see https://docs.sentry.io/product/performance/
     */
    readonly VITE_APP_SENTRY_TRACING_ENABLED: undefined | '0' | '1';

    /**
     * The release version according to SENTRY_RELEASE Environment variable to use when sending signals in the client.
     */
    readonly VITE_APP_SENTRY_RELEASE: string;

    /**
     * Value between 0 and 1.0 representing the sample rate of transactions for tracing.
     *
     * e.g. '1.0' for 100% coverage
     */
    readonly VITE_APP_SENTRY_TRACES_SAMPLE_RATE: string;

    /**
     * Since profilesSampleRate is relative to tracesSampleRate,
     * the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
     * For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
     * result in 25% of transactions being profiled (0.5*0.5=0.25)
     *
     * e.g. Set profilesSampleRate to 1.0 to profile every transaction.
     */
    readonly VITE_APP_SENTRY_PROFILES_SAMPLE_RATE: string;

    /**
     * Whether the symfony profiler toolbar should be enabled or not, where '1' is enabled and '0' is disabled.
     * @see https://github.com/MGDSoft/symfony-profiler-spa
     */
    readonly VITE_APP_SYMFONY_PROFILER_TOOLBAR_ENABLED: undefined | '0' | '1';
}
